import { Breakpoint, Color, FormButton, hexToRgba, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { AppZIndex, ViewImage } from '../../enums';

import { BannerSectionProps } from './trainingV2.types';

export const Container = styled.div`
  background-color: ${Color.Black100};
`;

export const TopBar = styled.div`
  border-bottom: 1px solid ${Color.Gray700};
  width: 100%;
  height: 58px;
  padding: 20px 16px;

  @media ${Breakpoint.Tablet} {
    padding: 20px;
  }
`;

export const BannerSection = styled.section<BannerSectionProps>`
  padding: 40px 16px;
  display: flex;
  flex-direction: column;
  background-image: ${({
    $backgroundImage,
  }: BannerSectionProps): string => `url(${$backgroundImage ?? ViewImage.TrainingV2DefaultBanner})`};
  background-size: cover;
  background-position: center;
  min-height: 352px;
  max-width: 100%;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    background: ${hexToRgba(Color.Black, 0.7)};
    inset: 0;

    @media ${Breakpoint.SmallDesktop} {
      background: linear-gradient(to top, ${hexToRgba(Color.Black, 0.8)}, ${Color.Transparent});
    }
  }

  & > * {
    z-index: ${AppZIndex.TrainingBannerContent};
  }

  @media ${Breakpoint.SmallDesktop} {
    aspect-ratio: 1360 / 560;
    flex-direction: row;
    justify-content: space-between;
    padding: 40px;
    align-items: flex-end;
  }
`;

export const BannerRightSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  justify-content: space-between;
  height: 100%;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: column-reverse;
    align-items: flex-end;
  }
`;

export const HeaderContent = styled.div`
  padding: 40px 16px;

  @media ${Breakpoint.SmallDesktop} {
    max-width: 50%;
    padding: 0;
  }
`;

export const StickyBar = styled.div`
  width: 100%;
  height: 56px;
  position: sticky;
  top: 0;
  background-color: ${Color.Black100};
  border-bottom: 1px solid ${Color.Gray700};
  display: flex;
  gap: 13.5px;
  justify-content: center;
  align-items: center;
  z-index: ${AppZIndex.StickyBar};

  @media ${Breakpoint.SmallDesktop} {
    gap: 24px;
  }
`;

export const RaysBar = styled.div`
  background-image: url(${ViewImage.TrainingV2RaysShape});
  width: 100%;
  height: 58px;
  background-position: right;
  background-repeat: no-repeat;
  border-bottom: 1px solid ${Color.Gray700};

  @media ${Breakpoint.SmallDesktop} {
    height: 80px;
  }
`;

export const ScrollButton = styled.button`
  border: none;
  background: none;
`;

export const Dot = styled.div`
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: ${Color.Gray700};
`;

export const ScrollButtonLabel = styled(Typography)`
  color: ${Color.Gray500};
`;

export const AboutTrainingSection = styled.section`
  padding: 40px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  border-bottom: 1px solid ${Color.Gray700};

  @media ${Breakpoint.Tablet} {
    padding: 60px 80px 80px;
  }
`;

export const AboutTrainingContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media ${Breakpoint.Tablet} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const TrainingGeneralText = styled(Typography)`
  width: 100%;
  color: ${Color.Gray300};

  @media ${Breakpoint.Tablet} {
    width: 40%;
  }
`;

export const TrainingDescription = styled(Typography)`
  width: 100%;
  color: ${Color.Gray500};

  @media ${Breakpoint.Tablet} {
    width: 49%;
  }
`;

export const AgendaSection = styled.section`
  padding: 40px 16px;
  display: flex;
  gap: 102px;

  @media ${Breakpoint.Tablet} {
    padding: 60px 80px;
  }
`;

export const Blocks = styled.img`
  width: 378px;
  height: 321px;
`;

export const PortfoliosSection = styled.section`
  padding: 40px 16px;

  @media ${Breakpoint.Tablet} {
    padding: 80px;
  }
`;

export const BottomBar = styled.div`
  width: 100%;
  height: 66px;
  border-top: 1px solid ${Color.Gray700};
`;

export const BottomBarInnerBox = styled.div`
  width: 50%;
  height: 100%;
  border-right: 1px solid ${Color.Gray700};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row-reverse;
  }
`;

export const CardsGroupSection = styled.section`
  padding: 20px 16px 0;

  @media ${Breakpoint.Tablet} {
    padding: 40px 80px 0;
  }
`;

export const StyledFormButton = styled(FormButton)`
  align-self: baseline;
`;
